<template>
  <div>
    <div class="search col-lg-12 col-md-12" v-if="user.admin">
      <div class="col-lg-3 col-md-3">
        <v-select placeholder="User" :options="users" v-model="selectedUser" @input="loadQueue"></v-select>
      </div>
    </div>
    <div class="table-responsive col-lg-12">
      <div v-if="assigned && assigned.length">
      <h3>Assigned to {{ user && selectedUser && user.id !== selectedUser.index ? selectedUser.label : 'me' }}</h3>
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Domain</th>
          <th>Client</th>
          <th>Order</th>
          <th>Added</th>
          <th>Completed</th>
          <th>Builder</th>
          <th>Priority</th>
          <th>Deadline</th>
          <th style="width: 290px;">
            <div class="col-lg-1" title="Layout Ready"><i class="fas fa-mountain"></i></div>
            <div class="col-lg-1" title="Demo Imported"><i class="fas fa-file-import"></i></div>
            <div class="col-lg-1" title="Built"><i class="fas fa-hammer"></i></div>
            <div class="col-lg-1" title="Content Ready"><i class="fa fa-file"></i></div>
            <div class="col-lg-1" title="Content Added"><i class="fas fa-file-upload"></i></div>
            <div class="col-lg-1" title="QA Passed"><i class="fa fa-check"></i></div>
            <div class="col-lg-1" title="Moved to Production"><i class="fa fa-arrow-right"></i></div>
            <div class="col-lg-1" title="Domain Moved to Client"><i class="fas fa-people-arrows"></i></div>
            <div class="col-lg-1" title="Delivered"><i class="fa fa-check"></i></div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="site in assigned" :key="site.id">
          <td><router-link :to="'/pbn/' + site.punyDomain">{{ site.domain }}</router-link></td>
          <td>{{ site.client ? site.client.name : '/' }}</td>
          <td>{{ site.order ? site.order.name : '/' }}</td>
          <td>{{ $moment(site.buildActions.added.endTime.date).fromNow() }}</td>
          <td>{{ site.buildActions['site-moved'].endTime ? $moment(site.buildActions['site-moved'].endTime.date).format('DD.MM.YY') : '' }}</td>
          <td>{{ site.buildActions['built'].assignee && site.buildActions['built'].assignee.name ? site.buildActions['built'].assignee.name : '?' }}</td>
          <td>
            <div class="label label-warning m-r-xs" v-if="site.buildInfo.priority >= 3">High</div>
            <div class="label label-primary m-r-xs" v-if="site.buildInfo.priority === 2">Normal</div>
            <div class="label label-default m-r-xs" v-if="site.buildInfo.priority <= 1">Low</div>
          </td>
          <td>{{ site.buildInfo.deadline ? $moment(site.buildInfo.deadline).fromNow()  : '/' }}</td>
          <td>
            <div class="col-lg-1">
              <action :action="site.buildActions['layout-ready']" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions['demo-imported']" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions.built" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions.content" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions['content-added']" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions.qa" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions['site-moved']" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions['domain-moved']" :user="user"></action>
            </div>
            <div class="col-lg-1">
              <action :action="site.buildActions.delivered" :user="user"></action>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      </div>
      <div v-if="started && started.length">
        <h3>Partial Builds</h3>
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Domain</th>
            <th>Client</th>
            <th>Order</th>
            <th>Added</th>
            <th>Completed</th>
            <th>Builder</th>
            <th>Priority</th>
            <th>Deadline</th>
            <th style="width: 290px;">
              <div class="col-lg-1" title="Layout Ready"><i class="fas fa-mountain"></i></div>
              <div class="col-lg-1" title="Demo Imported"><i class="fas fa-file-import"></i></div>
              <div class="col-lg-1" title="Built"><i class="fas fa-hammer"></i></div>
              <div class="col-lg-1" title="Content Ready"><i class="fa fa-file"></i></div>
              <div class="col-lg-1" title="Content Added"><i class="fas fa-file-upload"></i></div>
              <div class="col-lg-1" title="QA Passed"><i class="fa fa-check"></i></div>
              <div class="col-lg-1" title="Moved to Production"><i class="fa fa-arrow-right"></i></div>
              <div class="col-lg-1" title="Domain Moved to Client"><i class="fas fa-people-arrows"></i></div>
              <div class="col-lg-1" title="Delivered"><i class="fa fa-check"></i></div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="site in started" :key="site.id">
            <td><router-link :to="'/pbn/' + site.punyDomain">{{ site.domain }}</router-link></td>
            <td>{{ site.client ? site.client.name : '/' }}</td>
            <td>{{ site.order ? site.order.name : '/' }}</td>
            <td>{{ $moment(site.buildActions.added.endTime.date).fromNow() }}</td>
            <td>{{ site.buildActions['site-moved'].endTime ? $moment(site.buildActions['site-moved'].endTime.date).format('DD.MM.YY') : '' }}</td>
            <td>{{ site.buildActions['built'].assignee && site.buildActions['built'].assignee.name ? site.buildActions['built'].assignee.name : '?' }}</td>
            <td>
              <div class="label label-warning m-r-xs" v-if="site.buildInfo.priority >= 3">High</div>
              <div class="label label-primary m-r-xs" v-if="site.buildInfo.priority === 2">Normal</div>
              <div class="label label-default m-r-xs" v-if="site.buildInfo.priority <= 1">Low</div>
            </td>
            <td>{{ site.buildInfo.deadline ? $moment(site.buildInfo.deadline).fromNow()  : '/' }}</td>
            <td>
              <div class="col-lg-1">
                <action :action="site.buildActions['layout-ready']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['demo-imported']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.built" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.content" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['content-added']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.qa" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['site-moved']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['domain-moved']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.delivered" :user="user"></action>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="priority && priority.length">
        <h3>Priority Builds</h3>
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Domain</th>
            <th>Client</th>
            <th>Order</th>
            <th>Added</th>
            <th>Completed</th>
            <th>Builder</th>
            <th>Priority</th>
            <th>Deadline</th>
            <th style="width: 290px;">
              <div class="col-lg-1" title="Layout Ready"><i class="fas fa-mountain"></i></div>
              <div class="col-lg-1" title="Demo Imported"><i class="fas fa-file-import"></i></div>
              <div class="col-lg-1" title="Built"><i class="fas fa-hammer"></i></div>
              <div class="col-lg-1" title="Content Ready"><i class="fa fa-file"></i></div>
              <div class="col-lg-1" title="Content Added"><i class="fas fa-file-upload"></i></div>
              <div class="col-lg-1" title="QA Passed"><i class="fa fa-check"></i></div>
              <div class="col-lg-1" title="Moved to Production"><i class="fa fa-arrow-right"></i></div>
              <div class="col-lg-1" title="Domain Moved to Client"><i class="fas fa-people-arrows"></i></div>
              <div class="col-lg-1" title="Delivered"><i class="fa fa-check"></i></div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="site in priority" :key="site.id">
            <td><router-link :to="'/pbn/' + site.punyDomain">{{ site.domain }}</router-link></td>
            <td>{{ site.client ? site.client.name : '/' }}</td>
            <td>{{ site.order ? site.order.name : '/' }}</td>
            <td>{{ $moment(site.buildActions.added.endTime.date).fromNow() }}</td>
            <td>{{ site.buildActions['site-moved'].endTime ? $moment(site.buildActions['site-moved'].endTime.date).format('DD.MM.YY') : '' }}</td>
            <td>{{ site.buildActions['built'].assignee && site.buildActions['built'].assignee.name ? site.buildActions['built'].assignee.name : '?' }}</td>
            <td>
              <div class="label label-warning m-r-xs" v-if="site.buildInfo.priority >= 3">High</div>
              <div class="label label-primary m-r-xs" v-if="site.buildInfo.priority === 2">Normal</div>
              <div class="label label-default m-r-xs" v-if="site.buildInfo.priority <= 1">Low</div>
            </td>
            <td>{{ site.buildInfo.deadline ? $moment(site.buildInfo.deadline).fromNow()  : '/' }}</td>
            <td>
              <div class="col-lg-1">
                <action :action="site.buildActions['layout-ready']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['demo-imported']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.built" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.content" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['content-added']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.qa" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['site-moved']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions['domain-moved']" :user="user"></action>
              </div>
              <div class="col-lg-1">
                <action :action="site.buildActions.delivered" :user="user"></action>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Actions from '../List/Actions'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      assigned: [],
      priority: [],
      started: [],
      users: [],
      selectedUser: null
    }
  },
  components: {
    action: Actions
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    this.loadQueue()
    if (this.user.admin) {
      this.getUsers()
    }
  },
  methods: {
    loadQueue (user = null) {
      let userId = user ? user.index : this.user.id
      axios.get('/pbn/build/show-pbns?type=assigned&user=' + userId)
        .then(r => {
          this.assigned = r.data.data
          let missing = 10 - this.assigned.length
          axios.get('/pbn/build/show-pbns?type=started&limit=' + missing + '&user=' + userId)
            .then(r => {
              this.started = r.data.data
              axios.get('/pbn/build/show-pbns?type=priority&limit=' + (missing - (r.data.data ? r.data.data.length : 0)) + '&user=' + userId)
                .then(r => {
                  this.priority = r.data.data
                })
                .catch()
            })
            .catch()
        })
        .catch()
    },
    loadStarted () {
    },
    getUsers () {
      axios.get('/users?pbnPermission=1&operator=6163160e757197395775b0f2')
        .then(r => {
          this.builders = []
          r.data.forEach(u => {
            this.users.push({
              index: u.id,
              label: u.name || u.username
            })
          })
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Queue/List.vue